export enum EtapasCierreTurno {
    Etp1 = 'Etapa 1: Realizar cierre',
    Etp2 = 'Etapa 2: Carga de datos',
    Etp3 = 'Etapa 3: Cuadros de comparativas',
    Etp4 = 'Etapa 4: Parte diario',
    Fin = 'Finalizar Turno'
}